import { Link } from "react-router-dom";
import BrandMark from "@/components/masar/BrandMark";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function LegalShell({ title, updated, children }) {
  const { t } = useLanguage();
  return (
    <main className="min-h-screen bg-black text-neutral-100 selection:bg-[#FF6A1A] selection:text-white">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-black/80 border-b border-white/10">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="legal-nav-home">
            <BrandMark size={36} />
            <span className="font-semibold text-lg tracking-tight text-white">MASAR</span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-neutral-300 hover:text-white transition-colors"
            data-testid="legal-back-home"
          >
            <ArrowLeft size={16} />
            {t("legal.back")}
          </Link>
        </div>
      </header>

      <article className="max-w-4xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
        <div className="text-xs font-mono uppercase tracking-widest text-[#FF6A1A]">
          {t("legal.legal")}
        </div>
        <h1 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight leading-[1.05] text-white">
          {title}
        </h1>
        <p className="mt-3 text-sm text-neutral-500 font-mono">{t("legal.lastUpdated")} {updated}</p>

        <div className="mt-10 max-w-none [&_h2]:mt-12 [&_h2]:text-2xl [&_h2]:font-semibold [&_h2]:tracking-tight [&_h2]:text-white [&_h3]:mt-8 [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-neutral-100 [&_p]:leading-relaxed [&_p]:text-neutral-300 [&_p]:mt-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:text-neutral-300 [&_ul]:mt-3 [&_li]:mt-1.5 [&_a]:text-[#FF6A1A] [&_a]:underline [&_a]:underline-offset-4">
          {children}
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-sm text-neutral-400">
            {t("legal.questions")}{" "}
            <a
              href="mailto:emailsupport@masar.ltd"
              className="text-[#FF6A1A] underline underline-offset-4"
            >
              emailsupport@masar.ltd
            </a>
          </p>
          <div className="flex items-center gap-4 text-sm">
            <Link to="/privacy" className="text-neutral-300 hover:text-white transition-colors">
              {t("footer.privacyLink")}
            </Link>
            <Link to="/terms" className="text-neutral-300 hover:text-white transition-colors">
              {t("footer.termsLink")}
            </Link>
            <Link to="/" className="text-neutral-300 hover:text-white transition-colors">
              {t("legal.home")}
            </Link>
          </div>
        </div>
      </article>
    </main>
  );
}
